if(ID.bodyCart) addEventListener("DOMContentLoaded", _=> {
    let autoWidth = input => input.style.width = Math.max(input.value.length,1) + "ch";
    document.querySelectorAll(".amount input[type=text]").forEach(input => {
        autoWidth(input);
        input.addEventListener("input", _=> autoWidth(input));
    });
});